export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE" as const;
export const RESET_FILTERS = "RESET_FILTERS" as const;
export const SET_ACTIVE_ELEMENT_ID = "SET_ACTIVE_ELEMENT_ID" as const;
export const UPDATE_FILTER_VALUE = "UPDATE_FILTER_VALUE" as const;
export const APPLY_FILTERS = "APPLY_FILTERS" as const;